<script setup lang="ts">
import { useWangsVueConfig } from 'lib/plugins/WangsVue';

import Button from '../button/Button.vue';

defineProps<{
  customRequirements?: string[];
  showInfo: boolean;
  showAddButton?: boolean;
}>();

defineEmits<{
  addPhoto: [];
}>();

const { locale } = useWangsVueConfig('ImageCompressor');
</script>

<template>
  <div class="flex flex-col gap-y-4">
    <ul
      v-if="showInfo"
      :class="[
        'text-xs font-normal text-grayscale-900 dark:text-white',
        `[&_li]:before:content-['•']`,
        '[&_li]:before:inline-block [&_li]:before:w-[12px] [&_li]:before:ml-[-12px] pl-3',
        'max-w-[121px] [&_li]:pl-0.5',
      ]"
      data-wv-section="image-requirements-info"
    >
      <template v-if="customRequirements?.length">
        <li :key="info" v-for="info in customRequirements">
          {{ info }}
        </li>
      </template>

      <template v-else>
        <li>{{ locale.maxSizeRequirement }}</li>

        <li>{{ locale.imageTypeRequirement }}</li>
      </template>
    </ul>

    <Button
      v-if="showAddButton"
      @click="$emit('addPhoto')"
      icon="add"
      label="Add Photo"
      text
    />

    <slot />
  </div>
</template>
